import React, { useState } from 'react';
import { useNavigate, Link, useSearchParams } from 'react-router-dom';
import { register } from '../services/api';

const Register = () => {
    const navigate = useNavigate();
    const [searchParams] = useSearchParams();
    const token = searchParams.get('token');

    const [formData, setFormData] = useState({
        name: '',
        email: '',
        password: '',
        password_confirmation: '',
        token: token || ''
    });
    const [error, setError] = useState('');
    const [showPassword, setShowPassword] = useState(false);
    const [showConfirmPassword, setShowConfirmPassword] = useState(false);

    const handleChange = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (formData.password !== formData.password_confirmation) {
            setError("Passwords do not match");
            return;
        }
        try {
            const response = await register(formData);
            localStorage.setItem('token', response.data.access_token);
            localStorage.setItem('user', JSON.stringify(response.data.user));
            navigate('/');
        } catch (err) {
            setError(err.response?.data?.message || 'Registration failed');
        }
    };

    return (
        <div id="auth-page">
            <div className="shape shape-1"></div>
            <div className="shape shape-2"></div>
            <div className="shape shape-3"></div>

            <div className="auth-card">
                <div className="icon-container">
                    <i className="bi bi-person-plus"></i>
                </div>
                <div className="auth-header mb-4">
                    <h3>Create Account</h3>
                    <p className="text-muted">Join the team today!</p>
                </div>

                {error && <div className="alert alert-danger">{error}</div>}

                <form onSubmit={handleSubmit}>
                    <div className="mb-3 text-start">
                        <label className="form-label text-muted fw-bold">Full Name</label>
                        <input
                            type="text"
                            name="name"
                            className="form-control"
                            placeholder="John Doe"
                            value={formData.name}
                            onChange={handleChange}
                            required
                        />
                    </div>
                    <div className="mb-3 text-start">
                        <label className="form-label text-muted fw-bold">Email</label>
                        <input
                            type="email"
                            name="email"
                            className="form-control"
                            placeholder="mail@simmmple.com"
                            value={formData.email}
                            onChange={handleChange}
                            required
                        />
                    </div>

                    <div className="row">
                        <div className="col-6 mb-4 text-start">
                            <label className="form-label text-muted fw-bold">Password</label>
                            <div className="position-relative">
                                <input
                                    type={showPassword ? "text" : "password"}
                                    name="password"
                                    className="form-control"
                                    placeholder="Min. 8 chars"
                                    value={formData.password}
                                    onChange={handleChange}
                                    required
                                />
                                <button 
                                    type="button"
                                    className="btn border-0 position-absolute end-0 top-50 translate-middle-y"
                                    onClick={() => setShowPassword(!showPassword)}
                                    style={{ zIndex: 10 }}
                                >
                                    <i className={`bi bi-eye${showPassword ? '-slash' : ''}`}></i>
                                </button>
                            </div>
                        </div>
                        <div className="col-6 mb-4 text-start">
                            <label className="form-label text-muted fw-bold">Confirm</label>
                            <div className="position-relative">
                                <input
                                    type={showConfirmPassword ? "text" : "password"}
                                    name="password_confirmation"
                                    className="form-control"
                                    placeholder="Re-enter"
                                    value={formData.password_confirmation}
                                    onChange={handleChange}
                                    required
                                />
                                <button 
                                    type="button"
                                    className="btn border-0 position-absolute end-0 top-50 translate-middle-y"
                                    onClick={() => setShowConfirmPassword(!showConfirmPassword)}
                                    style={{ zIndex: 10 }}
                                >
                                    <i className={`bi bi-eye${showConfirmPassword ? '-slash' : ''}`}></i>
                                </button>
                            </div>
                        </div>
                    </div>

                    <button type="submit" className="btn-auth">Register</button>
                </form>

                <div className="mt-4 text-muted">
                    Already have an account? <Link to="/login" className="text-primary fw-bold hover-underline">Sign In</Link>
                </div>
            </div>
        </div>
    );
};

export default Register;
